import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SaveLastVisitedPages from "./SaveLastVisitedPages";

const TrackVisitedPages = ({ prefix = "" }) => {
    const location = useLocation();
    useEffect(() => {
        SaveLastVisitedPages(location.pathname, prefix);
    }, [location]);
    return null;
};

export default TrackVisitedPages;